var map = {
	"./planet_earth_black.png": 9540,
	"./planet_earth_blue.png": 4525,
	"./planet_earth_grey.png": 8916,
	"./planet_earth_red.png": 2256,
	"./planet_jupiter_black.png": 6939,
	"./planet_jupiter_blue.png": 704,
	"./planet_jupiter_grey.png": 4165,
	"./planet_jupiter_red.png": 611,
	"./planet_mars_black.png": 8769,
	"./planet_mars_blue.png": 3178,
	"./planet_mars_grey.png": 3499,
	"./planet_mars_red.png": 3641,
	"./planet_mercury_black.png": 9847,
	"./planet_mercury_blue.png": 4148,
	"./planet_mercury_grey.png": 1537,
	"./planet_mercury_red.png": 7847,
	"./planet_moon_black.png": 237,
	"./planet_moon_blue.png": 6574,
	"./planet_moon_grey.png": 9079,
	"./planet_moon_red.png": 9549,
	"./planet_neptune_black.png": 7319,
	"./planet_neptune_blue.png": 9284,
	"./planet_neptune_grey.png": 4913,
	"./planet_neptune_red.png": 8919,
	"./planet_pluto_black.png": 2938,
	"./planet_pluto_blue.png": 5287,
	"./planet_pluto_grey.png": 3458,
	"./planet_pluto_red.png": 6278,
	"./planet_saturn_black.png": 1827,
	"./planet_saturn_blue.png": 8040,
	"./planet_saturn_grey.png": 4941,
	"./planet_saturn_red.png": 3307,
	"./planet_sun_black.png": 26,
	"./planet_sun_blue.png": 4743,
	"./planet_sun_grey.png": 7970,
	"./planet_sun_red.png": 8214,
	"./planet_uranus_black.png": 9798,
	"./planet_uranus_blue.png": 6923,
	"./planet_uranus_grey.png": 14,
	"./planet_uranus_red.png": 1258,
	"./planet_venus_black.png": 8271,
	"./planet_venus_blue.png": 1004,
	"./planet_venus_grey.png": 5257,
	"./planet_venus_red.png": 6255
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2091;